import React from 'react';
import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import AddRoleForm from '../../../components/forms/role/AddRoleForm';
import PageHeader from '../../../components/common/PageHeader';

export default function AddRole() {
    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={'役割登録'} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/roles'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                <AddRoleForm />
            </Box>
        </>   
    ) 
}
